import { combineSubscriptions } from '@updater-core/lib/store/utils/combine';
import { createStore } from '@updater-core/lib/store';
import { JOURNEYS } from './constants';

function noState() {
  throw new Error('State must be passed into selector');
}

export function createInteractor({ session, siteBranding }) {
  const subscriptionStream = combineSubscriptions({
    session,
    siteBranding,
  });
  const { getState, setState, subscribe } = createStore({});

  const fetchJourney = new Promise((resolve) => {
    const disconnect = subscriptionStream.connect(
      ({ session: sessionState, siteBranding: siteBrandingState }) => {
        const journey =
          session.selectors.journey(sessionState) ||
          siteBranding.selectors.journey(siteBrandingState);

        if (journey) {
          disconnect();
          setState({
            journeyFetched: true,
            journey,
          });
          resolve();
        }
      }
    );
  });

  /* 
      TODO: hasNewHeaderPromise can be removed from the app now 
    */
  function hasNewHeaderPromise() {
    return fetchJourney.then(() => true);
  }

  return {
    getState,
    connect: (fn) => {
      fn(getState());
      return subscribe(fn);
    },
    subscribe,
    actions: {
      /* A way to know on-demand when this is resolved without connecting. */
      fetchJourney: () => fetchJourney.then(() => getState()),
      hasNewHeaderPromise,
    },
    selectors: {
      journeyFetched: (state = noState()) => state.journeyFetched || false,
      signoutDisabled: (state = noState()) =>
        state.journey === JOURNEYS.UTILITY,
      disableMoverDropdown: (state = noState()) =>
        state.journey === JOURNEYS.UTILITY,
      footerConfig: (state = noState()) => state.journey.toUpperCase(),
      hasAccessToAccountFeatures: (state = noState()) =>
        state.journey !== JOURNEYS.UTILITY,
      hasNewDashboard: (state = noState()) =>
        state.journey === JOURNEYS.UTILITY,
    },
    destroy() {},
  };
}
